import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import MessagingWorkspace from '@/components/messaging/MessagingWorkspace';
import { messagingAPI } from '@/services/api';

const BRMMessages = () => {
  const [params] = useSearchParams();
  const [initialConversation, setInitialConversation] = useState(null);
  useEffect(() => {
    const campaignId = params.get('campaignId');
    const clientId = params.get('clientId');
    if (!campaignId || !clientId) return;
    messagingAPI.createConversation({ campaign_id: campaignId, client_id: clientId })
      .then((result) => setInitialConversation({ ...result.conversation, campaign_title: result.conversation.campaign_title || 'Campaign', other_party: { id: clientId, name: 'Campaign client', type: 'client' } }))
      .catch(() => {});
  }, [params]);
  return <MessagingWorkspace role="brm" title="Messages" description="Keep client conversations and campaign decisions together." initialConversation={initialConversation}/>;
};

export default BRMMessages;
